import React from "react";
import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button,
		CardText,
		FormGroup,
		Label,
		Card,
		CardBody,
		CardFooter,
		CardHeader,
		Modal,
		ModalHeader,
		ModalBody,
		ModalFooter,
		Row,
		Col,
	} from "reactstrap";
import { api, PAYMENT_STATUS, SOCKET, socket, USER_TYPES, LOCAL_STORAGE_USER as LOCAL_STORAGE_USER_KEY, OPEN_CASH_DRAWER } from "../../../util";

const SocketAdminStatus = () => {
  const user = useSelector((state) => state.user);
  const { socket: socketState } = useSelector((state) => state);
  const [billingData, setBillingData] = useState({
    checkoutList: [],
    paymentType: "",

    isPaymentComplete: false,
    isPaymentStarted: false,
    paymentStatus: PAYMENT_STATUS.NOT_STARTED,
    billId: null,
  });
  const [isClientActive, setIsClientActive] = useState(
    !!socketState.customerSocketId
  );
  const [isCurrentDeviceConnected, setIsCurrentDeviceConnected] =
    useState(true);

  useEffect(() => {
    if (!!socketState.customerSocketId) {
      setIsClientActive(true);
    } else {
      setIsClientActive(false);
    }
  }, [socketState.customerSocketId]);

  const handleSocketConnectionFail = (err) => {
    console.log("handleSocketConnectionFail", err);
    setIsCurrentDeviceConnected(false);
  };

  const connectionSuccess = (err) => {
    socket.emit(SOCKET.EMIT_JOIN, {
      roomId: user?.saloon?.roomId,
      from: {
        id: user.id,
        roleNumber: user.role,
        name: user.firstName,
        role: user.role === USER_TYPES.ADMIN ? "ADMIN" : "CUSTOMER",
      },
    });
    setIsCurrentDeviceConnected(true);
  };
  useEffect(() => {
    connectionSuccess()
    socket.on("connect", (err) => connectionSuccess(err));

    socket.on("CUSTOMER_FACING_DISCONNECTED", (data) => {
      // console.log("GOT PING FROM CLIENT 'CUSTOMER_FACING_DISCONNECTED'");
      setIsClientActive(false);
    });

    socket.on("CUSTOMER_FACING_CONNECTED", (id) => {
      if (id !== socket.id) {
        // console.log("GOT PING FROM CLIENT 'CUSTOMER_FACING_CONNECTED'");
        setIsClientActive(true);
      }
    });

    socket.on("connect_error", (err) => handleSocketConnectionFail(err));
    socket.on("connect_failed", (err) => handleSocketConnectionFail(err));
    socket.on("disconnect", (err) => handleSocketConnectionFail(err));

    return () => {
      socket.off("CUSTOMER_FACING_CONNECTED");
      socket.off("CUSTOMER_FACING_DISCONNECTED");

      socket.off("connect");
      socket.off("connect_error");
      socket.off("connect_failed");
      socket.off("disconnect");
    };
  }, []);

  var currentLoggedUserInfo = localStorage.getItem(LOCAL_STORAGE_USER_KEY);
  var currentLoggedUserInfoJson = JSON.parse(currentLoggedUserInfo);
  
  const openNoSalesDrawer = async () => {
    
    try {
		var drawerOpenReqObject = {};
		drawerOpenReqObject.saloon_id = currentLoggedUserInfoJson?.saloon?.id ;
        const response = await api.post("/square/open-drawer-request" , drawerOpenReqObject );
        if(response.status === 200) {
        	socket.emit(SOCKET.EMIT_DISPLAY_NOTIFICATION,{});
        	setShowValidateOTPPopup(true);
        }
    } catch (error) {
    	console.log(error);
    }
  };
  
  
  
  const validateNoSalesOpenDrawerOTP = async () => {
	
	if (noSalesVerifyOTPNumber === null || noSalesVerifyOTPNumber === ""){
		toast.error("Please Enter Valid OTP Number.");
		return false;  
	}
    try {
		var drawerOpenReqObject = {};
		
		drawerOpenReqObject.saloon_id = currentLoggedUserInfoJson?.saloon?.id ;
		drawerOpenReqObject.otp_number = noSalesVerifyOTPNumber ;
		
        const response = await api.post("/square/validate-drawer-request-otp" , drawerOpenReqObject );
        
        if(response.status === 200) {
        	toast.success(response?.data?.message);
        	setShowValidateOTPPopup(false);
        	if (OPEN_CASH_DRAWER === 1){
            	var allowedShopIds = [1, 2,  4, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18];
        		if (allowedShopIds.includes(drawerOpenReqObject.saloon_id)) {
					const secondResponse = await axios.get("http://localhost:3002/open-drawer-2");
					console.log("Localhost call response:", secondResponse.data);
				}
			}
        } else {
        	toast.error(response?.data?.message);
        }
        
    } catch (error) {
    	console.log(error);
    	toast.error(error.response?.data?.message || error.message);
    }
  };
  
  
  
  const reconnectSocket = async () => {
    try {
      socket.disconnect();
      socket.connect();
      socket.emit(SOCKET.EMIT_JOIN, {
        roomId: user?.saloon?.roomId,
        from: {
          id: user.id,
          roleNumber: user.role,
          name: user.firstName,
          role: user.role === USER_TYPES.ADMIN ? "ADMIN" : "CUSTOMER",
        },
      });

      try {
        const response = await api.get(
          "/square/billing-state/" + user?.saloon?.roomId
        );
        const { billingObject } = response?.data?.data;
        if (billingObject) {
          setBillingData(billingObject);
          socket.emit(SOCKET.EMIT_BILLING_DATA_CHANGE, billingObject);
        } else {
          socket.emit(SOCKET.EMIT_BILLING_DATA_CHANGE, billingData);
        }
        setIsClientActive(true);
      } catch (error) {
        console.log(error);
        setIsClientActive(false);
        // toast.error(error.response?.data?.message || error.message);
      }
    } catch (error) {
      setIsClientActive(false);
      toast.error("Couldn't re-establish the connection, Please refresh.");
      console.log(error);
    }
  };
  
  const [showValidateOTPPopup, setShowValidateOTPPopup] = useState(false);
  const [noSalesVerifyOTPNumber , setNoSalesVerifyOTPNumber] = useState(null);

  return (
    <div className="status_wrapper">
    <Button
	    type="button"
	    size="sm"
	    title="No Sales"
	    color="secondary"
	    onClick={(e) => {
	    	openNoSalesDrawer();
	    }}
	  >
	    <i className="bi bi-arrow-clockwise"></i>
	  </Button>
	  
		<Button
	        type="button"
	        size="sm"
	        title="Refresh connection"
	        disabled={isCurrentDeviceConnected}
	        color={isCurrentDeviceConnected ? "secondary" : "primary"}
	        onClick={(e) => {
	          e.preventDefault();
	          reconnectSocket();
	        }}
	      >
	        <i className="bi bi-arrow-clockwise"></i>
	      </Button>
      <CardText className="d-flex gap-2 mb-0 fs-6">
        Status of current device :
        {isCurrentDeviceConnected ? (
          <div className="fw-bolder">
            <i className="bi bi-wifi text-success fs-6"></i> Connected
          </div>
        ) : (
          <div className="fw-bolder">
            <i className="bi bi-wifi fs-5 text-danger"></i> Disconnected
          </div>
        )}
      </CardText>
      <CardText className="d-flex gap-2 fs-6">
        Status of client device :
        {isCurrentDeviceConnected ? (
          isClientActive ? (
            <div className="fw-bolder">
              <i className="bi bi-wifi text-success fs-6 fw-bold"></i> Connected
            </div>
          ) : (
            <div className="fw-bolder">
              <i className="bi bi-wifi fs-6 fw-bold text-danger"></i> Disconnected
            </div>
          )
        ) : (
          <div className="fw-bolder">
            <i className="bi bi-wifi fs-6 fw-bold text-warning"></i> Unknown
          </div>
        )}
      </CardText>
      {showValidateOTPPopup === true && (
    		  <Modal isOpen={showValidateOTPPopup}  className="clock-summary-modal" size="lg" centered>
			     <ModalHeader>
			     	<h4 className="mb-0 fw-bolder">
				     	<span className="text-success text-center" style={{fontSize: '26px'}}>
	    				Validate OTP
	    				</span>
    				</h4>
   			     </ModalHeader>
   			     <ModalBody className="p-0">
   			      		<Card className="newdashboard-table shadow-none mb-0">
   			      		<CardBody className="px-2 py-0">
		   			       <Row>
							<Col xl={6} md={6} sm={12} xs={12}>
								<FormGroup>
									<Label for="confirmation_code">
										Enter Confirmation Code
									</Label>
									<input
										onChange={(e) => {
											setNoSalesVerifyOTPNumber(e.target.value);
										}}
										id="confirmation_code"
										name="confirmation_code"
										placeholder="Confirmation Code"
										type="text"
										maxLength={6}
										autoComplete="off"
										className={
											"form-control"
										}
									/>
								</FormGroup>
							</Col>
						</Row>
						</CardBody>
					</Card>
				</ModalBody>
				<ModalFooter>
					<Button color="success" className="btn-sm m-2"
			      			onClick={(e) => {
			      				validateNoSalesOpenDrawerOTP()
		                    }}
			      			>
			      			Validate OTP
			      	</Button>
			    </ModalFooter>
			</Modal>
      )}
    </div>
  );
};

export default SocketAdminStatus;
